import React from "react";
import { Box, Typography, Grid, Card, CardContent, Button, TextField, Divider } from "@mui/material";

export const JuniorProductManagerDashboard = () => {
  const tasks = [
    { id: 1, title: "Assist in preparing market analysis report", dueDate: "2025-04-20", status: "In Progress" },
    { id: 2, title: "Compile feedback from product feature requests", dueDate: "2025-04-22", status: "Pending" },
    { id: 3, title: "Coordinate with the design team for UI updates", dueDate: "2025-04-25", status: "Completed" },
  ];

  const handleSubmitUpdate = () => {
    alert("Task update submitted successfully!");
  };

  return (
    <Box
      sx={{
        padding: 4,
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      <Typography variant="h4" component="h1" gutterBottom align="center">
        Junior Product Manager Dashboard
      </Typography>
      <Typography variant="body1" color="textSecondary" gutterBottom align="center">
        Welcome to your dashboard! View your tasks and submit updates to the Associate Product Manager.
      </Typography>

      <Divider sx={{ marginY: 3 }} />

      <Grid container spacing={4}>
        {/* Task List */}
        {tasks.map((task) => (
          <Grid item xs={12} sm={6} md={4} key={task.id}>
            <Card elevation={3}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  {task.title}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Due Date: {task.dueDate}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Status: {task.status}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}

        {/* Submit Updates Section */}
        <Grid item xs={12}>
          <Card elevation={3}>
            <CardContent>
              <Typography variant="h6" gutterBottom align="center">
                Submit Task Updates
              </Typography>
              <TextField
                label="Task Update"
                multiline
                rows={4}
                fullWidth
                variant="outlined"
                sx={{ marginBottom: 2 }}
              />
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleSubmitUpdate}
              >
                Submit Update
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default JuniorProductManagerDashboard;